export default __webpack_public_path__ + "static/media/DiscoBall_Loop_600px_v001.179178c3.gif";